/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
 * tree and available online at
 *
 * https://www.atmire.com/software-license/
 */
import { Component, Input } from '@angular/core';
import { AtmireAbstractListableElementComponent } from '../../../../../../app-atmire/shared/object-collection/shared/object-collection-element/atmire-abstract-listable-element.component';
import { listableObjectComponent } from '../../../../../../app/shared/object-collection/shared/listable-object/listable-object.decorator';
import { Community } from '../../../../../../app/core/shared/community.model';
import { LinkService } from '../../../../../../app/core/cache/builders/link.service';
import { ViewMode } from '../../../../../../app/core/shared/view-mode.model';
import { hasNoValue, hasValue } from '../../../../../../app/shared/empty.util';
import { followLink } from '../../../../../../app/shared/utils/follow-link-config.model';
import { Context } from '../../../../../../app/core/shared/context.model';
import { MultilingualMetadataService } from '../../../../../../app-atmire/core/shared/multilingual-metadata.service';

/**
 * Component representing a grid element for a community
 */
@Component({
  selector: 'ds-community-grid-element',
  styleUrls: ['./community-grid-element.component.scss'],
  templateUrl: './community-grid-element.component.html'
})

@listableObjectComponent(Community, ViewMode.GridElement, Context.Any, 'atmire')
export class CommunityGridElementComponent extends AtmireAbstractListableElementComponent<Community> {
  private _object: Community;

  constructor(
    private linkService: LinkService,
    protected multilingualMetadataService: MultilingualMetadataService,
  ) {
    super(multilingualMetadataService);
  }

  // @ts-ignore
  @Input() set object(object: Community) {
    this._object = object;
    if (hasValue(this._object) && hasNoValue(this._object.logo)) {
      this.linkService.resolveLink<Community>(this._object, followLink('logo'));
    }
  }

  get object(): Community {
    return this._object;
  }
}
